import React from 'react';
export function WhatYouGet() {
  return <section className="w-full bg-[#0a0a0a] py-16 px-4 pt-[10px] pb-[10px]" data-id="element-363">
      <div className="max-w-5xl mx-auto" data-id="element-364">
        <h2 className="text-3xl sm:text-4xl font-black text-white text-center mb-12" data-id="element-365">
          Lo que <span className="text-[#FFD700]" data-id="element-366">recibís</span>
        </h2>

        <div className="max-w-2xl mx-auto mb-12" data-id="element-367">
          <div className="bg-black border border-[#FFD700]/30 rounded-2xl p-6" data-id="element-368">
            <h3 className="text-[#FFD700] text-xl font-black mb-4" data-id="element-369">
              💃 LOS 6 TOMOS
            </h3>
            <div className="space-y-3" data-id="element-370">
              <div className="flex items-start gap-3 text-white" data-id="element-371">
                <span className="text-lg" data-id="element-372">🟢</span>
                <p className="text-sm" data-id="element-373">
                  <span className="font-bold" data-id="element-374">
                    Tomo 1 — Fundamentos y Metodología
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-375">
                    · 18 secuencias didácticas · Framework de clase · Planillas
                    y dinámicas
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-376">
                <span className="text-lg" data-id="element-377">🟡</span>
                <p className="text-sm" data-id="element-378">
                  <span className="font-bold" data-id="element-379">
                    Tomo 2 — Laboratorio de Técnica
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-380">
                    · 40 ejercicios progresivos en 5 categorías · 4 niveles cada
                    uno
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-381">
                <span className="text-lg" data-id="element-382">🟠</span>
                <p className="text-sm" data-id="element-383">
                  <span className="font-bold" data-id="element-384">
                    Tomo 3 — Musicalidad en el Salón
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-385">
                    · 8 orquestas fundamentales · Sistema de 3 capas · 15
                    actividades
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-386">
                <span className="text-lg" data-id="element-387">🔴</span>
                <p className="text-sm" data-id="element-388">
                  <span className="font-bold" data-id="element-389">
                    Tomo 4 — Retención y Motivación
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-390">
                    · 7 causas del abandono · Sistema de 4 Pilares · Semáforo de
                    Retención
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-391">
                <span className="text-lg" data-id="element-392">🟣</span>
                <p className="text-sm" data-id="element-393">
                  <span className="font-bold" data-id="element-394">
                    Tomo 5 — Guiones de Corrección
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-395">
                    · 80+ guiones exactos · Sistema en 5 Niveles · Protocolo
                    grupal e individual
                  </span>
                </p>
              </div>
              <div className="flex items-start gap-3 text-white" data-id="element-396">
                <span className="text-lg" data-id="element-397">⭐</span>
                <p className="text-sm" data-id="element-398">
                  <span className="font-bold" data-id="element-399">
                    Tomo 6 — El Negocio del Profe
                  </span>{' '}
                  <span className="text-gray-400" data-id="element-400">
                    · Precios · Captación · Instagram · Plan de negocio anual
                  </span>
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-[#FFD700]/5 border border-[#FFD700]/30 rounded-2xl p-8 text-center" data-id="element-401">
          <h3 className="text-[#FFD700] text-xl font-black mb-6" data-id="element-402">
            Cada tomo incluye:
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-3xl mx-auto" data-id="element-403">
            <div className="flex items-start gap-2 text-left" data-id="element-404">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-405">✅</span>
              <span className="text-white text-sm" data-id="element-406">
                Planificador semanal listo para usar
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-407">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-408">✅</span>
              <span className="text-white text-sm" data-id="element-409">
                Clases con objetivo, actividad y cierre
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-410">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-411">✅</span>
              <span className="text-white text-sm" data-id="element-412">
                Criterios de promoción por nivel
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-413">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-414">✅</span>
              <span className="text-white text-sm" data-id="element-415">
                Evaluaciones + rúbricas (escala 1-4)
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-416">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-417">✅</span>
              <span className="text-white text-sm" data-id="element-418">
                Fichas de seguimiento por alumno
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-419">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-420">✅</span>
              <span className="text-white text-sm" data-id="element-421">
                Diplomas imprimibles + checklist de egreso
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-422">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-423">✅</span>
              <span className="text-white text-sm" data-id="element-424">
                Material original ProfePack®
              </span>
            </div>
            <div className="flex items-start gap-2 text-left" data-id="element-425">
              <span className="text-[#FFD700] font-bold flex-shrink-0" data-id="element-426">✅</span>
              <span className="text-white text-sm" data-id="element-427">
                100% adaptado al profe de tango argentino
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}